<template>
  <component :is="component" class="logo" v-bind="$attrs">
    <span class="logo__text">
      App
    </span>
    <img class="logo__img" :src="require(`@/assets/themes/${BRAND_KEY}/images/logo-mobile-${theme}.svg`)" />
    <span class="logo__text">
      <slot name="suffix">Market</slot>
    </span>
  </component>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    component: {
      type: String,
      default: 'router-link',
    },
  },
  computed: {
    ...mapState(['theme']),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.logo {
  display: flex;
  gap: 5px;
  align-items: center;
  color: var(--text-primary);
  font-size: 25px;
  font-weight: 500;
  letter-spacing: -1px;
  flex-shrink: 0;

  &__text {
    position: relative;
    top: -2px;

    @include notebook {
      top: 0;

      &:first-child {
        display: none;
      }
    }
  }

  &__img {
    max-width: 100%;
    height: 37px;

    &_mobile {
      display: none;

      @include notebook {
        display: block;
      }
    }

    &_desktop {
      @include notebook {
        display: none;
      }
    }
  }
}
</style>
